import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';

import { FieldPhoneNumberInputComponent } from './field-phone-number-input.component';

@NgModule({
  declarations: [
    FieldPhoneNumberInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    FieldPhoneNumberInputComponent
  ]
})
export class FieldPhoneNumberInputModule { }
